export class Constants {
  public static APPLICATION_ID = 'ais_app_inv';
  public static DEFAULT_DROP_DOWN_VALUE = '- Select -';
  public static DEFAULT_SELECT_ITEM = {
    label: Constants.DEFAULT_DROP_DOWN_VALUE,
    value: Constants.DEFAULT_DROP_DOWN_VALUE,
  };
  public static ERR_IMAGE_TITLE_EXISTS = "ERR_IMAGE_TITLE_EXISTS";
  public static DATE_RESTRICTION = "DateRestriction";
  public static ENTER_DATE_MANUALLY = "EnterDateManually";
  public static MULTIPLE_CHOICE = "MultipleChoice";
  
}
